import React from 'react';

import {
	Icon,
	styled
} from 'ps-gui';

const Wrapper = styled.a`
	font-size: 16px;
	position: relative;
	vertical-align: middle;
	.icon {
		margin-right: 4px;
		position: relative;
		top: -1px;
	}
	text-decoration: none;
	&:hover {
		* {
			text-decoration: underline;
		}

	}
	color: ${props => props.theme.textColor};
	margin: ${props => props.margin};
`;

const Prefix = styled.span`
	font-weight: 400;
`;

const Number = styled.span`
	font-weight: 700;
`;

export default class PhoneNumber extends React.PureComponent {
	render() {
		let value = this.props.value;
		if (this.props.preset === 'intergram') {
			value = '+420602615292';
		}
		if (!value) {
			return null;
		}
		return (
			<Wrapper href={'tel:' + value} margin={this.props.margin}>
				<Icon
					name="phone"
				/>
				<Prefix>{value.substring(0, 4)+'\u00A0'}</Prefix>
				<Number>{value.substring(4, 7)+'\u00A0'}</Number>
				<Number>{value.substring(7, 10)+'\u00A0'}</Number>
				<Number>{value.substring(10)}</Number>
			</Wrapper>
		);
	}
}
